import { createSelector } from '@reduxjs/toolkit'
import store, { RootState } from '../../../../store'
import { useDispatch } from 'react-redux'
import { useEffect } from 'react'
import { SceneManager } from '../../../../visualization/sceneManager'
import { updateHistory } from '../../../../actions/history'
import { ActionType } from '../../../../reducers/history'
import { EventType } from '../../../../utils/EventEmitter'
import {
  editStructuralElement,
  EditStructuralElementPayload,
} from '../../../../actions/construction'

const convertDataSelector = createSelector(
  (state: RootState) => state.construction,
  (construction) => construction.convertData,
)

const EditStructuralElement = () => {
  const dispatch = useDispatch()

  useEffect(() => {
    const eventEmitter = SceneManager.getInstance().getEventEmitter()
    if (!eventEmitter) {
      return
    }

    const handleEditStructuralElement = (
      editStructuralElementPayload: EditStructuralElementPayload,
    ) => {
      dispatch(editStructuralElement(editStructuralElementPayload))

      const convertData = structuredClone(convertDataSelector(store.getState()))
      dispatch(
        updateHistory({
          convertData,
          items: [
            {
              itemId: editStructuralElementPayload.id,
              actionType: ActionType.EDIT,
            },
          ],
        }),
      )
    }

    eventEmitter.on(
      EventType.BuildingEditStructuralElement,
      handleEditStructuralElement,
    )

    return () => {
      eventEmitter.off(
        EventType.BuildingEditStructuralElement,
        handleEditStructuralElement,
      )
    }
  }, [dispatch])

  return null
}

export default EditStructuralElement
